import { useEffect, useLayoutEffect, useState } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { useStore } from '@stores/RootStore';
import { WorkflowDetailHeader } from '../detail/WorkflowDetailHeader';
import { ActionSelect } from '../detail/action/ActionSelect';
import { ConditionSelect } from '../detail/condition/ConditionSelect';
import { WorkflowViewer } from '../detail/graph/WorkflowViewer';
import { OptionBar } from '../detail/info/OptionBar';
import { TriggerSelect } from '../detail/trigger/TriggerSelect';

export const WorkflowCreatePage = observer(() => {
  const { workflowDetailStore } = useStore();
  const [isToolbarOpen, setIsToolbarOpen] = useState<boolean>(false);

  useLayoutEffect(() => {
    workflowDetailStore.setIsEdit(true);
  }, [workflowDetailStore]);

  useEffect(() => {
    setIsToolbarOpen(!!workflowDetailStore.toolbar);
  }, [workflowDetailStore.toolbar]);

  return (
    <Container>
      <Header>
        <WorkflowDetailHeader />
      </Header>
      <Body>
        <WorkflowViewer />
        <OptionBar open={isToolbarOpen}>
          {/* 트리거 선택 화면 */}
          {workflowDetailStore.toolbar === 'triggerSelect' && <TriggerSelect key="triggerSelect" />}
          {/* 액션 선택 화면 */}
          {workflowDetailStore.toolbar === 'actionSelect' && <ActionSelect key="actionSelect" />}
          {/* 조건 선택 화면 */}
          {workflowDetailStore.toolbar === 'conditionSelect' && <ConditionSelect key="conditionSelect" />}
        </OptionBar>
      </Body>
    </Container>
  );
});

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 23px 32px 0px;
  gap: 13px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Body = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme: { colors } }) => colors['border-gray-lighter']};
  border-radius: 4px;
  width: 100%;
  height: calc(100vh - 136px);
  box-shadow: 0px 1px 0px 0px #00000005, 0px 0px 3px 0px #00000012;
`;
